<template></template>
<script>
///////////////////////////////////////////////////////////////////////////////
// пришлось создать данный компонент, так как vue-router не умеет
// делать синхронный redirect
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'oldRoutes',
	//=========================================================================
	created() {
		if (this.$route &&
			this.$route.params &&
			typeof this.$route.params === 'object' &&
			'vdsGroupId' in this.$route.params)
		{
			this.getVdsGroups(String(this.$route.params.vdsGroupId))
		}
	},
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		getVdsGroups(groupId) {
			// обнулим группу для фильтра
			this.$store.commit('setFilteredGroupId', null)

			// мы должны запросить горуппу VDS
			let _url = this.APIServerUrl + '/service/list?search=group&type=vds'

			// делаем запрос
			this.$http.get(_url)
			.then(resGet => {
				// получаем ответ
				if (resGet && resGet['ok'] === true && resGet['status'] === 200 && resGet['body'] &&
					typeof resGet['body'] === 'object' && resGet['body']['status'] === 'ok' &&
					resGet['body']['result'] && resGet['body']['result'].length)
				{
					let groups = resGet['body']['result']
					let found = false
					groups.some(item => {
						if (String(item.id) === groupId)
						{
							found = true
							return true
						}
					})

					if (found)
					{
						this.$store.commit('setFilteredGroupId', groupId)
						this.$router.replace('/vds/list')
						return
					}
				}

				throw new Error()
			})
			.catch(() => { this.$router.replace('/vds/list') })
		}

		//---------------------------------------------------------------------
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// oldRoutes.vue?63795456